import { render, staticRenderFns } from "./TheApp.vue?vue&type=template&id=7915c815&"
import script from "./TheApp.vue?vue&type=script&lang=js&"
export * from "./TheApp.vue?vue&type=script&lang=js&"
import style0 from "./TheApp.vue?vue&type=style&index=0&id=7915c815&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports